import { Translate, useTranslation } from "@privacy/translations";
import { DynamicHistory } from "../dynamicHistory";
import type { BaseHistoryEntry, CustomHistoryEntry } from "../dynamicHistory/types";
import { STATUS_WORDS } from "./StatusWord";

export const AuditPostponedEntry = ({
  entry,
  organisation,
}: {
  entry: BaseHistoryEntry & CustomHistoryEntry<"registrationAuditPostponed", string>;
  organisation?: string;
}) => {
  const { formatDate } = useTranslation();
  return (
    <DynamicHistory.BeforeAndAfterEntry
      {...entry}
      header={
        <Translate
          translationKey={
            organisation
              ? "SharedProcessing.History.AuditPostponedAtOrganisation"
              : "RegistrationHistory.AuditPostponed"
          }
          values={{ organisation, ...STATUS_WORDS }}
        />
      }
      before={<DynamicHistory.SnapshotValueText>{formatDate(entry.oldValue)}</DynamicHistory.SnapshotValueText>}
      after={<DynamicHistory.SnapshotValueText>{formatDate(entry.newValue)}</DynamicHistory.SnapshotValueText>}
    />
  );
};
